'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const timespan=require('pulsar-utils/dist-es6/time/timespan');

const ZeroDuration=timespan.fromMilliseconds(0);let

HosStatusDurations=function(){
function HosStatusDurations(){let offDuty=arguments.length>0&&arguments[0]!==void 0?arguments[0]:ZeroDuration;let sleeperBerth=arguments.length>1&&arguments[1]!==void 0?arguments[1]:ZeroDuration;let driving=arguments.length>2&&arguments[2]!==void 0?arguments[2]:ZeroDuration;let onDuty=arguments.length>3&&arguments[3]!==void 0?arguments[3]:ZeroDuration;let drivingOffDuty=arguments.length>4&&arguments[4]!==void 0?arguments[4]:ZeroDuration;_classCallCheck(this,HosStatusDurations);
_.ensureInstanceOf(timespan.TimeSpan,offDuty);
_.ensureInstanceOf(timespan.TimeSpan,sleeperBerth);
_.ensureInstanceOf(timespan.TimeSpan,driving);
_.ensureInstanceOf(timespan.TimeSpan,onDuty);
_.ensureInstanceOf(timespan.TimeSpan,drivingOffDuty);

this._offDuty=offDuty;
this._sleeperBerth=sleeperBerth;
this._driving=driving;
this._onDuty=onDuty;
this._drivingOffDuty=drivingOffDuty;
}HosStatusDurations.prototype.





















toJSON=function toJSON(){
return{
offDuty:this._offDuty.totalMilliseconds(),
sleeperBerth:this._sleeperBerth.totalMilliseconds(),
driving:this._driving.totalMilliseconds(),
onDuty:this._onDuty.totalMilliseconds(),
drivingOffDuty:this._drivingOffDuty.totalMilliseconds()};

};HosStatusDurations.

fromJSON=function fromJSON(jsonStatusDurations){
return new HosStatusDurations(
timespan.fromMilliseconds(jsonStatusDurations.offDuty),
timespan.fromMilliseconds(jsonStatusDurations.sleeperBerth),
timespan.fromMilliseconds(jsonStatusDurations.driving),
timespan.fromMilliseconds(jsonStatusDurations.onDuty),
timespan.fromMilliseconds(jsonStatusDurations.drivingOffDuty));
};HosStatusDurations.

fromPoints=function fromPoints(hosPoints,endTime){let{json=!1}=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{};
let durationsObject=new HosStatusDurations().toJSON();

if(hosPoints.length>0){
const unixEndTime=endTime.getTime();

durationsObject=_(hosPoints).
map(function(_ref){let{time:time,value:value}=_ref;return{time:time.getTime(),value:value}}).
sortBy(function(tsp){return tsp.time}).
filter(function(tsp){return tsp.time<=unixEndTime}).
concat({time:unixEndTime,value:'END'}).
reduce(function(durations,tsp,index,points){
if(index===0){
return durations;
}

durations[_.lowerFirst(points[index-1].value.status.name)]+=tsp.time-points[index-1].time;

return durations;
},durationsObject);
}

return json===!0?
durationsObject:
HosStatusDurations.fromJSON(durationsObject);
};_createClass(HosStatusDurations,[{key:'offDuty',get:function(){return this._offDuty}},{key:'sleeperBerth',get:function(){return this._sleeperBerth}},{key:'driving',get:function(){return this._driving}},{key:'onDuty',get:function(){return this._onDuty}},{key:'drivingOffDuty',get:function(){return this._drivingOffDuty}}]);return HosStatusDurations}();


module.exports=HosStatusDurations;
//# sourceMappingURL=hosStatusDurations.js.map
